
import axios from "axios";
import moment from "moment/moment";
import React, { useContext, useEffect }  from 'react';

import Button from "@material-ui/core/Button";
import { FormContext } from 'core/FormProvider';
import { ContextWidget, ContextFormControlWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import FormGroup from 'form/FormGroup';
import { Grid } from 'ui/Grid';
import PointsOrderForm from './Forms/PointsForm';
import ExtraServicesOrderForm from './Forms/ExtraServicesForm';
import ExtraOrderFieldForm from './Forms/ExtraFieldsForm';
import TransportOrderForm from './Forms/TransportForm.js'
import OrderTotalAmount from './Forms/TotalAmount.js';
import TariffOrderForm from './Forms/TariffForm';
import { AsyncAutocompleteWidget } from 'form/AutocompleteWidget';
import { AsyncAutocompleteMultipleWidget } from 'form/AutocompleteMultipleWidget';
import { AsyncAutocompleteWidget2 } from 'form/AutocompleteWidget2';
import { DateTimeWidget } from 'form/new/DateTimeWidget';
import { DatetimeActions } from "form/DatetimeActions";
import DateMaskedWidget from "form/DateMaskedWidget";
import OrderUploadDocuments from "./UploadDocument/UploadDocuments";
import ToggleChangesList from "../Changes/ToggleList";
import OrderCreateUploadDocuments from "./UploadDocument/OrderCreateUploadDocuments";

export default function FormOrder() {
  const formContext = useContext(FormContext);
  const item = formContext.item;

  useEffect(() => {
    if (item.order_status && !item.order_status.is_canceled && !item.order_status.is_completed) {
      if (item.date_start && item.carrier && item.counterparty) {
        axios.get('client/contract', {
          params: {
            carrier: item.carrier.id,
            counterparty: item.counterparty.id,
            date_start__lte: moment(item.date_start).format('YYYY-MM-DD'),
            date_end__gte: moment(item.date_start).format('YYYY-MM-DD')
          }
        }).then(res => {
          formContext.setContext('has_contract', res.data.total > 0);
        })
      }
    }
  }, [item.date_start, item.carrier, item.counterparty])

  useEffect(() => {
    if (item.id || item.order_payment_status) {
      return;
    }
    axios.get('catalog/order_payment_status').then(res => {
      const statuses = res.data.results || [];
      const unpaid = statuses.find(status => status.label === 'Не оплачено');
      if (unpaid) {
        formContext.setValue('order_payment_status', unpaid);
      }
    });
  }, []);

  const handleClientChange = (context, value) => {
    if (value === null || value === undefined) {
      context.setValues({
        client: null,
        counterparty: null,
        contact_persons: []
      })
    }
    else {
      context.setValue('client', value);
    }
  }

  const handleCounterpartyChange = (context, value) => {
    if (value === null || value === undefined) {
      context.setValues({
        counterparty: null,
        contact_persons: []
      })
    }
    else {
      context.setValue('counterparty', value);
    }
  }

  return (
    <FormContext.Consumer>
      {context => {
        const { item, originalItem } = context;

        return (
          <React.Fragment>
            <FormGroup>
              <ContextFormControlWidget
                name={'order_status'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  url: 'catalog/order_status',
                  label: 'Статус перевозки',
                  optionLabel: 'label'
                }}
              />

              <ContextFormControlWidget
                name={'order_payment_status'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  url: 'catalog/order_payment_status',
                  label: 'Статус оплаты',
                  optionLabel: 'label'
                }}
              />

              <ContextFormControlWidget
                name={'order_type'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  label: 'Тип перевозки',
                  url: 'catalog/choice',
                  optionLabel: 'name',
                  filter: {
                    type: 'ORDER_TYPE'
                  }
                }}
              />

              <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
                <ContextWidget
                  name={`station_arrival_date`}
                  WidgetComponent={DateMaskedWidget}
                  widgetProps={{
                    label: 'Дата прихода на станцию'
                  }}
                />
                <ContextWidget
                  name={`station_arrival_notify_date`}
                  WidgetComponent={DateMaskedWidget}
                  widgetProps={{
                    label: 'Дата уведомления'
                  }}
                />
              </Grid>

              <ContextFormControlWidget
                name={'date_start'}
              >
                <DateTimeWidget
                  value={item.date_start}
                  label={'Дата начала перевозки'}
                  onChange={(value, stringValue) => context.setDateTimeValue('date_start', value)}
                />
                <DatetimeActions
                  value={item.date_start}
                  onChange={(value) => context.setDateTimeValue('date_start', value)}
                  className={'mt-5'}
                />
              </ContextFormControlWidget>

              <ContextFormControlWidget
                name={'date_end'}
              >
                <DateTimeWidget
                  value={item.date_end}
                  minDate={item.date_start}
                  label={'Дата завершения перевозки'}
                  openToDate={item.date_start ? moment(item.date_start).toDate() : undefined}
                  onChange={(value, stringValue) => context.setDateTimeValue('date_end', value)}
                />
                <DatetimeActions
                  value={item.date_end}
                  onChange={(value) => context.setDateTimeValue('date_end', value)}
                  className={'mt-5'}
                >
                  {item.date_start && (
                    <Button
                      onClick={() => context.setDateTimeValue('date_end', moment(item.date_start).endOf('day'))}>
                      {moment(item.date_start).format('DD.MM')}
                    </Button>
                  )}
                </DatetimeActions>
              </ContextFormControlWidget>

              <TransportOrderForm />

              <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
                <ContextWidget
                  name={'container_number'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: '№ контейнера'
                  }}
                />

                <ContextFormControlWidget
                  name={'container_owner'}
                  WidgetComponent={AsyncAutocompleteWidget}
                  widgetProps={{
                    label: 'Собственник',
                    url: 'catalog/choice',
                    filter: {
                      type: 'CONTAINER_OWNER'
                    }
                  }}
                />
              </Grid>

              <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
                <ContextFormControlWidget
                  name={'container_type'}
                  WidgetComponent={AsyncAutocompleteWidget}
                  widgetProps={{
                    label: 'Типоразмер',
                    url: 'catalog/choice',
                    filter: {
                      type: 'CONTAINER_TYPE'
                    }
                  }}
                />

                <ContextWidget
                  name={`cargo_weight`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Вес груза (кг)',
                    emptyValue: null
                  }}
                />
              </Grid>

              <ContextFormControlWidget
                name={'carrier'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  label: 'Перевозчик',
                  url: 'catalog/choice',
                  filter: {
                    type: 'CARRIER',
                    is_active_or_id: originalItem.carrier ? originalItem.carrier.id : true
                  }
                }}
              />

              <ContextFormControlWidget
                name={'client'}
                WidgetComponent={AsyncAutocompleteWidget2}
                widgetProps={{
                  url: 'client',
                  label: 'Клиент',
                  filter: {
                    page_size: 50,
                    is_active_or_id: originalItem.client ? originalItem.client.id : true
                  },
                  optionLabel: 'name',
                  onChange: (valueId, value) => handleClientChange(context, value)
                }}
              />

              {item.client && (
                <ContextFormControlWidget
                  name={'counterparty'}
                  WidgetComponent={AsyncAutocompleteWidget}
                  widgetProps={{
                    label: 'Контрагент',
                    url: 'client/counterparty',
                    optionLabel: 'name',
                    filter: {
                      client: item.client.id
                    },
                    onChange: (value) => handleCounterpartyChange(context, value)
                  }}
                />
              )}

              {item.counterparty && (
                <ContextFormControlWidget
                  name={'contact_persons'}
                  WidgetComponent={AsyncAutocompleteMultipleWidget}
                  widgetProps={{
                    label: 'Контактные лица',
                    url: 'client/contact_person',
                    optionLabel: 'name',
                    filter: { counterparty: item.counterparty.id },
                  }}
                />
              )}

              <TariffOrderForm />
            </FormGroup>

            <PointsOrderForm />

            <ExtraServicesOrderForm />

            <OrderTotalAmount item={item}/>

            <ExtraOrderFieldForm />

            {item.id && (
              <div style={{maxWidth: '465px'}}>
                <OrderUploadDocuments order={item}/>
              </div>
            )}

            {!item.id && (
              <div style={{maxWidth: '465px'}}>
                <OrderCreateUploadDocuments formContext={context}/>
              </div>
            )}

            {item.id && (
              <div style={{maxWidth: '465px', marginTop: '20px'}}>
                <ToggleChangesList
                  item={item}
                />
              </div>
            )}

          </React.Fragment>
        )
      }}
    </FormContext.Consumer>
  )
}
